import type { BoardMetadata } from "../model/board.js";
import type { PositionRecord } from "../model/position.js";

export function projectBoardSummary(board: BoardMetadata) {
  return {
    createdAt: board.createdAt,
    dict: board.dict,
    profile: board.profile,
    rootPositionId: board.rootPositionId,
    selectedPositionId: board.selectedPositionId,
    sessionKey: board.sessionKey,
    status: board.status,
    tipPositionId: board.tipPositionId,
    updatedAt: board.updatedAt,
    version: board.version,
  };
}

export function projectPositionSummary(position: PositionRecord) {
  return {
    createdAt: position.createdAt,
    depth: position.depth,
    evaluation: position.evaluation,
    id: position.id,
    moveKind: position.moveKind,
    movePayload: position.movePayload,
    moveSummary: position.moveSummary,
    parentPositionId: position.parentPositionId,
    stateHash: position.stateHash,
  };
}
